import clsx from 'clsx';
import { useToast } from '../shared/useToast.js';
import { Icon } from './Icon.jsx';

const tones = {
  success: 'bg-[#DCFCE7] border-[#86EFAC] text-[#15803D]',
  error: 'bg-[#FEE2E2] border-[#FCA5A5] text-[#B91C1C]',
  warning: 'bg-[#FEF3C7] border-[#FDE68A] text-[#92400E]',
  info: 'bg-[#CFFAFE] border-[#67E8F9] text-[#0E7490]'
};

const icons = {
  success: 'check',
  error: 'x',
  warning: 'bell',
  info: 'bell'
};

export function ToastViewport() {
  const toasts = useToast((s) => s.toasts);
  const remove = useToast((s) => s.remove);

  if (!toasts.length) return null;

  return (
    <div className="fixed top-4 left-4 z-[100] flex flex-col gap-2 pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={clsx(
            'pointer-events-auto card flex items-center gap-2.5 px-3.5 py-2.5 border min-w-[260px] max-w-[420px] shadow-pop',
            tones[t.type] || tones.info
          )}
        >
          <Icon name={icons[t.type] || 'bell'} size={16} />
          <div className="flex-1 text-[13px] font-semibold">{t.message}</div>
          <button
            type="button"
            className="opacity-60 hover:opacity-100"
            onClick={() => remove(t.id)}
            title="إغلاق"
          >
            <Icon name="x" size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
